import { BlocksIconEmail } from 'blocks-nextjs/blocks-web-components/components/icon/icons/email';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconEmail = createComponent({ react: React, tagName: 'cat-icon-email', elementClass: BlocksIconEmail });
